import React from "react";
import { Box, Button } from "@mui/material";

interface Props {
  canConfirm: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

const ObjectiveSelectFooter: React.FC<Props> = ({ canConfirm, onCancel, onContinue }) => {
  return (
    <Box
      mt={2.5}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
    >
      <Button
        variant="text"
        onClick={onCancel}
        sx={{
          fontFamily: "Montserrat",
          fontWeight: 600,
          color: "#336B87",
          fontSize: "0.87rem",
        }}
      >
        CANCELAR Y VOLVER A OBJETIVOS
      </Button>

      <Button
        variant="contained"
        disabled={!canConfirm}
        onClick={onContinue}
        sx={{
          borderRadius: "12px",
          px: 3.5,
          fontFamily: "Montserrat",
          fontSize: "0.87rem",
          fontWeight: 600,
          backgroundColor: "#336B87",
          "&:hover": { backgroundColor: "#16303D" },
        }}
      >
        SELECCIONAR Y CONTINUAR
      </Button>
    </Box>
  );
};

export default ObjectiveSelectFooter;
